import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { gql } from 'providers/tanstack-query/utils'

import type { Data, Variables } from './types'
import type { TypedDocumentNode } from 'providers/tanstack-query/types'

export const SIGN_OUT: TypedDocumentNode<Data, Variables> = gql`
  ${ERROR_FRAGMENT}

  mutation signOut {
    signOut(input: {}) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
